import IsLoading from "@/components/layouts/IsLoading"
import AuthenticatedUserContext from "@/contexts/authentication/AuthenticatedUserContext";
import InstitutionsContext from "@/contexts/data/InstitutionsContext"
import { generateSlug } from "@/utils";
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router";

const InstitutionDefaultRedirectPage = () => {
    const { data, error } = useContext(InstitutionsContext);
    const { isBctStaff, isAdmin, isMedicalReviewer, isCentralScientist } = useContext(AuthenticatedUserContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (data) {
            if (data.length === 0) {
                navigate('/no-online-roles', { replace: true });
                return;
            }

            if (isBctStaff || isAdmin || isMedicalReviewer || isCentralScientist) {
                navigate('/all-institutions', { replace: true });
                return;
            }
            
            const institution = data[0];

            navigate(`/${institution.id}/${generateSlug(institution.name ?? 'unknown')}`, { replace: true });
        }
        else if (error) {
            navigate('/error/500', { replace: true });
        }
    }, [data, error, navigate, isBctStaff, isAdmin, isMedicalReviewer, isCentralScientist]);

    return (
        <IsLoading name="InstitutionDefaultRedirect" loading={true} validating={false} />
    )
}

export default InstitutionDefaultRedirectPage
